const resumablePaths = ["/external-access", "/tool-approvals", "/capabilities"];

export function isResumablePostAuthPath(value: string | null | undefined): value is string {
  if (!value?.startsWith("/")) return false;
  const url = new URL(value, "https://agent-platform.local");
  return url.origin === "https://agent-platform.local"
    && resumablePaths.some((path) => url.pathname === path || url.pathname.startsWith(`${path}/`));
}
